import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { components } from "react-select";
import OptionValueContents from "../OptionValueContents";
import { jsx as _jsx } from "react/jsx-runtime";
function CustomSingleValue(props) {
  var data = props.data;
  return /*#__PURE__*/_jsx(components.SingleValue, _extends({}, props, {
    children: /*#__PURE__*/_jsx(OptionValueContents, {
      label: data.label,
      statusBadgeProps: data.statusBadgeProps
    })
  }));
}
export default CustomSingleValue;